import { render, staticRenderFns } from "./home2.vue?vue&type=template&id=29069a2c&scoped=true"
import script from "./home2.vue?vue&type=script&lang=ts"
export * from "./home2.vue?vue&type=script&lang=ts"
import style0 from "./home2.vue?vue&type=style&index=0&id=29069a2c&prod&lang=scss&scoped=true"
import style1 from "./home2.vue?vue&type=style&index=1&id=29069a2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29069a2c",
  null
  
)

export default component.exports